import script from "./Example.vue?vue&type=script&lang=ts&setup=true"
export * from "./Example.vue?vue&type=script&lang=ts&setup=true"

import "./Example.vue?vue&type=style&index=0&id=5ecd2fa4&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecd2fa4"]])

export default __exports__